interface Props {
    className?: string;
}

export const SparklesIcon = ({ className }: Props) => (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.341 1.876a.667.667 0 0 1 1.31 0l.701 3.706a1.333 1.333 0 0 0 1.063 1.062l3.705.701a.667.667 0 0 1 0 1.31l-3.705.701a1.333 1.333 0 0 0-1.063 1.063l-.7 3.705a.666.666 0 0 1-1.31 0L6.64 10.42a1.333 1.333 0 0 0-1.062-1.063l-3.706-.7a.667.667 0 0 1 0-1.311l3.706-.7A1.333 1.333 0 0 0 6.64 5.581l.701-3.706zM13.336 1.332v2.667M14.667 2.668H12M2.67 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667z"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
